/* eslint-disable space-before-function-paren */
/* eslint-disable comma-dangle */
/* eslint-disable quotes */
import React from 'react';
import PageHeader from '../common/PageHeader';
import { transitionColumns, transitionListConfig } from '../../constants/MockData';
import GridTable from '../common/Table/Table';
import './style.less';
import { apiBatchRequest } from '../../utils/api_service';
import { API_URL } from '../../constants/api';
import { Tooltip, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import PageFilter from '../common/PageFilter';
import { controlType } from '../../constants/common';
import { ShowToast, toastType } from '../../utils/toast-service';
import commonLabels from '../../constants/messageConstants';
import AddEdit from '../Transition/AddEdit';
import moment from 'moment';
import {
  applyFilterOnData,
  IsSectionVisible,
  removeDuplicates,
  UpdateColumnWithConfiguration,
  useQuery
} from '../../utils/helper';
import TransitionTracker from './TransitionTracker';
import _ from 'lodash';
import FullScreenDialog from '../common/Dialog/Dialog';
import { Operators, SECTIONS, DateFormat } from '../../constants/appConstants';
import { Visibility } from '@material-ui/icons';
import FullPageLoader from '../../views/loader/fullPage-loader';

class Transition extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      transitionData: [],
      isLoading: true,
      transitionTypeListingData: [],
      propertyMasterData: [],
      serviceTypeMasterData: [],
      marketMasterData: [],
      propertyTypeMasterData: [],
      propertySubTypeMasterData: [],
      configuration: undefined,
      addEditView: false,
      employeeTypeMasterData: undefined,
      editMode: undefined,
      selectedEditId: 0,
      selectedTransitionId: 0,
      clientListingMasterData: undefined,
      reloadPage: (((this.props || {}).location || {}).navProps || {}).reload,
      url: undefined,
      pdfView: false,
      readOnly: false,
      useQueryStringData: true,
      disableAddButton: true,
      fetchedInActiveRecords: false
    };
  }

  componentDidMount() {
    this.LoadData();
    // this.OpenPTFDetails();
  }

  OpenPTFDetails = () => {
    const query = useQuery();
    // const transitionId = query.get('transitionId');
    const ptfNumber = query.get('ptfNumber');
    const transitionType = query.get('transitionType');

    if (ptfNumber !== null && this.state.responseTransitionData !== undefined && this.state.useQueryStringData === true) {
      // const row = this.state.responseTransitionData.filter(x => x.transitionId?.toString() === transitionId);
      const row = this.state.responseTransitionData.filter(x => x.ptfNumber?.toString() === ptfNumber && x.transitionType?.toString().toLowerCase().replaceAll(" ", "") === transitionType);
      if (row !== null && row !== undefined && row.length > 0) {
        this.setState({
          addEditView: true,
          editMode: 'Edit',
          selectedEditId: row[0].propertyId,
          selectedTransitionId: row[0].transitionId, // transitionId,
          selectedClientId: row[0].clientId,
          rowData: row
          // readOnly
        });
      }
    }
    if (!this.state.useQueryStringData) {
      const updatedUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
      window.history.pushState({ path: updatedUrl }, '', updatedUrl);
    }
  }

  static getDerivedStateFromProps(newProps, state) {
    if ((((newProps || {}).location || {}).navProps || {}).reload !== (state || {}).reload) {
      // this.LoadData();
      return {
        p: '',
        reload: (((newProps || {}).location || {}).navProps || {}).reload,
        addEditView: false,
        editMode: undefined,
        selectedEditId: 0,
        trackerview: false,
        selectedTransitionId: 0,
        pdfView: false,
      };
    }
  }

  LoadData() {
    this._asyncRequest = apiBatchRequest([
      {
        // url: API_URL.Transition.GetTransitionData,
        url: `${API_URL.Transition.GetTransitionData}?showInActivePTF=false`,
        key: 'transitionData',
      },
      {
        url: API_URL.Transition.GetTransitionTypeListingData,
        key: 'transitionTypeListingData',
        fromCache: false,
        duration: 60
      },
      {
        url: API_URL.Property.GetPropertyMasterData,
        key: 'propertyMasterData',
      },
      {
        url: API_URL.Assignments.GetServiceTypeMasterData,
        key: 'serviceTypeMasterData',
        fromCache: false,
        duration: 10
      },
      {
        url: API_URL.Assignments.GetServiceTypeMasterData + '?outputType=ListAll',
        key: 'serviceTypeAllMasterData',
        fromCache: false,
        duration: 60
      },
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeTypeMasterData',
        fromCache: false,
        duration: 15
      },
      {
        url: API_URL.Transition.GetClientListingData,
        key: 'clientListingMasterData',
      },
      {
        url: API_URL.Market.GetMarketMasterdata,
        key: 'marketMasterData',
        fromCache: true,
        duration: 10
      },
      {
        url: API_URL.Property.GetPropertyTypeMasterData,
        key: 'propertyTypeMasterData',
        fromCache: true,
        duration: 60
      },
      {
        url: API_URL.Property.GetPropertySubType,
        key: 'propertySubTypeMasterData',
        fromCache: true,
        duration: 60
      }
    ])
      .then(
        ({
          transitionData,
          transitionTypeListingData,
          propertyMasterData,
          serviceTypeMasterData,
          employeeTypeMasterData,
          clientListingMasterData,
          serviceTypeAllMasterData,
          marketMasterData,
          propertyTypeMasterData,
          propertySubTypeMasterData
        }) => {
          this._asyncRequest = null;
          if (transitionData.success === true) {
            const statusData = removeDuplicates(transitionData?.data?.map(x => {
              return { approvalStatusId: x.approvalStatusId, approvalStatus: x.approvalStatus };
            }), 'approvalStatusId') || [];

            const uniqueAssignmentData = removeDuplicates(transitionData?.data?.map(x => {
              return { assignmentId: x.assignmentId, assignmentName: x.assignmentName };
            }), 'assignmentName') || [];
            this.setState({
              responseTransitionData: _.cloneDeep(transitionData.data || []),
              transitionData: _.cloneDeep(transitionData.data || []),
              transitionTypeListingData: transitionTypeListingData.data || [],
              configuration: transitionData.config || [],
              propertyMasterData: propertyMasterData.data || [],
              serviceTypeMasterData: serviceTypeMasterData.data || [],
              serviceTypeAllMasterData: serviceTypeAllMasterData.data || [],
              selectedData: [],
              employeeTypeMasterData: employeeTypeMasterData.data || [],
              clientListingMasterData: clientListingMasterData.data || [],
              marketMasterData: marketMasterData.data || [],
              propertyTypeMasterData: propertyTypeMasterData.data || [],
              propertySubTypeMasterData: propertySubTypeMasterData.data || [],
              statusData,
              uniqueAssignmentData,
              disableAddButton: false,
              isLoading: false
            },
              () => {
                this.OpenPTFDetails();
              }
            );
            // this.OpenPTFDetails();
          } else {
            this.setState({ isLoading: false });
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          'Server error'
        );
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  componentWillUnmount() {
    if (this._asyncRequest) {
      // this._asyncRequest.cancel();  to do - need to handle promise
    }
  }

  renderActionColumn = (row) => {
    return (
      <>
        {row?.inactivePTF === true
          ? IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) &&
          <Tooltip title="View">
            <IconButton
              aria-label={'refreshData'}
              size="small"
              onClick={() => {
                this.editTransition(row.propertyId, row.transitionId, row.clientId, row, true);
              }}
            >
              <Visibility fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
          : <>
            {IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) &&
              row.parentId === row.transitionId && (row.approvalStatusId !== 4 || row.transitionTypeId === 1) &&
              <Tooltip title="Edit">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.editTransition(row.propertyId, row.transitionId, row.clientId, row);
                  }}
                >
                  <EditIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            }
            {IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) &&
              row.parentId !== row.transitionId && row.approvalStatusId === 4 && row.transitionTypeId === 1 &&
              <Tooltip title="Edit">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.editTransition(row.propertyId, row.transitionId, row.clientId, row);
                  }}
                >
                  <EditIcon fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            }
            {IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) &&
              row.parentId === row.transitionId && row.approvalStatusId === 4 && row.transitionTypeId !== 1 &&
              <Tooltip title="View">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.editTransition(row.propertyId, row.transitionId, row.clientId, row, true);
                  }}
                >
                  <Visibility fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            }
            {IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) &&
              row.parentId !== row.transitionId && row.approvalStatusId === 4 && row.transitionTypeId === 3 &&
              <Tooltip title="View">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.editTransition(row.propertyId, row.transitionId, row.clientId, row, true);
                  }}
                >
                  <Visibility fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            }
            {IsSectionVisible(SECTIONS.PROPERTY_TRANSITION) &&
              IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT) === false &&
              // row.parentId === row.transitionId &&
              <Tooltip title="View">
                <IconButton
                  aria-label={'refreshData'}
                  size="small"
                  onClick={() => {
                    this.editTransition(row.propertyId, row.transitionId, row.clientId, row, true);
                  }}
                >
                  <Visibility fontSize="small" size="small" />
                </IconButton>
              </Tooltip>
            }
          </>
        }
      </>
    );
  };

  editTransition = (propertyId, transitionId, clientId, row, readOnly = false) => {
    this.setState({
      addEditView: true,
      editMode: 'Edit',
      selectedEditId: propertyId,
      selectedTransitionId: transitionId,
      selectedClientId: clientId,
      rowData: row,
      readOnly
    });
  };

  onFilterChange = (selectedData) => {
    const showInActiveObj = (selectedData.find((m) => m.key === 'showInActivePTF') || {});
    const { fetchedInActiveRecords } = this.state;
    let showInActivePTF = false;
    if (showInActiveObj.selected === undefined) {
      showInActivePTF = false;
    } else if (showInActiveObj.selected !== undefined && showInActiveObj.selected.length > 0) {
      if (showInActiveObj.selected[0].showInActivePTF === false) {
        showInActivePTF = false;
      } else {
        showInActivePTF = true;
      }
    }

    if (fetchedInActiveRecords !== showInActivePTF) {
      // API call
      this.setState({ selectedData }, () => {
        this._asyncRequest = apiBatchRequest([
          {
            url: API_URL.Transition.GetTransitionData + '?showInActivePTF=' + showInActivePTF,
            key: 'transitionData'
          }
        ])
          .then(({ transitionData }) => {
            this._asyncRequest = null;
            if (transitionData.success !== true) {
              ShowToast(
                commonLabels.somethingWrong,
                toastType.ERROR,
                5000,
                500,
                'Server error'
              );
            }
            const filteredData = applyFilterOnData(_.cloneDeep(transitionData.data || []), selectedData);
            this.setState({
              responseTransitionData: _.cloneDeep(transitionData.data || []),
              transitionData: filteredData,
              fetchedInActiveRecords: showInActivePTF,
              selectedData
            });
          })
          .catch(() => {
            this._asyncRequest = null;
          });
      }
      );
    } else {
      const { responseTransitionData } = this.state;
      const filteredData = applyFilterOnData(_.cloneDeep([...responseTransitionData]), selectedData);
      // (selectedData || []).forEach((element) => {
      //   if (element.selected !== undefined && element.selected.length > 0) {
      //     if (element.key === 'showInActivePTF') {
      //       if (element.selected.length > 0 && element.selected[0].showInActivePTF === false) {
      //         return filteredData;
      //       } else {
      //         filteredData = filteredData.filter(x => (x.ptfEndDate === null) || (moment(x.ptfEndDate).format(DateFormat) >= moment().format(DateFormat)));
      //       }
      //     }
      //   }
      // });
      this.setState({ transitionData: filteredData, selectedData });
    }
  };

  onViewChange = () => {
    this.setState(
      {
        addEditView: false,
        editMode: undefined,
        selectedEditId: 0,
        trackerview: false,
        selectedTransitionId: 0,
        pdfView: false,
        useQueryStringData: false,
        fetchedInActiveRecords: false
      },
      () => {
        this.LoadData();
      }
    );
  };

  render() {
    const {
      selectedData,
      transitionData,
      transitionTypeListingData,
      propertyMasterData,
      serviceTypeMasterData,
      serviceTypeAllMasterData,
      addEditView,
      employeeTypeMasterData,
      trackerview,
      editMode,
      selectedEditId,
      selectedTransitionId,
      clientListingMasterData,
      openTagDataDialog,
      title,
      children,
      statusData,
      uniqueAssignmentData,
      marketMasterData,
      propertyTypeMasterData,
      propertySubTypeMasterData
    } = this.state;
    return (
      <>
        {openTagDataDialog && children &&
          <FullScreenDialog title={title} open={openTagDataDialog} close={() => {
            this.setState({ openTagDataDialog: false });
          }}>{children}</FullScreenDialog>}
        {addEditView === true
          ? (
            <AddEdit
              transitionTypeListingData={transitionTypeListingData}
              propertyMasterData={propertyMasterData}
              serviceTypeMasterData={serviceTypeAllMasterData}
              serviceTypeAllMasterData={serviceTypeAllMasterData}
              employeeTypeMasterData={employeeTypeMasterData}
              onViewChange={this.onViewChange}
              actionType={editMode}
              selectedPropertyId={selectedEditId}
              selectedTransitionId={selectedTransitionId}
              selectedClientId={this.state.selectedClientId}
              readOnly={this.state.readOnly}
            />
          )
          : trackerview === true
            ? (
              <TransitionTracker
                onViewChange={this.onViewChange}
                propertyMasterData={propertyMasterData}
              />
            )
            : (
              <>
                <br />
                {this.state.isLoading && <FullPageLoader requestCount={1} />}
                <PageHeader title="Property Transitions"></PageHeader>
                <PageFilter
                  autoFilter={false}
                  filterAlwaysVisible={true}
                  onFilterChanged={this.onFilterChange}
                  filterConfig={[
                    // {
                    //   multiple: false,
                    //   type: controlType.DropDown,
                    //   source: propertyMasterData,
                    //   key: 'propertyTypeName',
                    //   placeholder: 'Property Type',
                    //   title: 'Property Type',
                    // },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: marketMasterData,
                      key: 'marketName',
                      placeholder: 'Search Market',
                      title: 'Market'
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: transitionTypeListingData,
                      key: 'transitionTypeName',
                      placeholder: 'Transition Type',
                      title: 'Transition Type',
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: serviceTypeMasterData,
                      key: 'serviceType',
                      placeholder: 'Search Service Type',
                      title: 'Service Type',
                      isComaSeprated: true,
                      advanceFilter: true
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: propertyMasterData,
                      key: 'propertyName',
                      placeholder: 'Search Property',
                      title: 'Property Name',
                      isComaSeprated: true,
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: clientListingMasterData,
                      key: 'clientName',
                      placeholder: 'Search Client Name',
                      title: 'Client Name',
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: uniqueAssignmentData,
                      key: 'assignmentName',
                      placeholder: 'Search Service Type',
                      title: 'Legal Entity / Customer', // 'Assignment Name',
                      isComaSeprated: true
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      key: 'approvalStatus',
                      source: statusData,
                      placeholder: 'Status',
                      title: 'Status',
                      isComaSeprated: true
                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: propertyTypeMasterData,
                      key: 'propertyTypeName',
                      placeholder: 'Search Property type',
                      title: 'Property Type',
                      isComaSeprated: true,
                      advanceFilter: true
                    },
                    {
                      multiple: false,
                      type: controlType.DatePicker,
                      key: 'ptfStartDate',
                      title: 'Service(s) Start Date',
                      operator: Operators.GreaterThanEqualsTo
                    },
                    {
                      multiple: false,
                      type: controlType.DatePicker,
                      key: 'ptfEndDate',
                      title: 'Service(s) End Date',
                      operator: Operators.LessThanEqualsTo,
                      And: {
                        key: 'ptfStartDate',
                        operator: Operators.LessThanEqualsTo
                      }
                    },
                    {
                      multiple: false,
                      type: controlType.TextBox,
                      key: 'ptfNumber', // 'parentId',
                      title: 'PTF Number',
                      operator: Operators.EqualsTo

                    },
                    {
                      multiple: true,
                      type: controlType.DropDown,
                      source: propertySubTypeMasterData,
                      key: 'propertySubTypeName',
                      placeholder: 'Search Property Sub Type',
                      title: 'Property Sub Type',
                      isComaSeprated: true,
                      advanceFilter: true
                    },
                    {
                      type: controlType.Checkbox,
                      key: 'showInActivePTF',
                      placeholder: 'Search Property',
                      title: 'Show InActive Property Transitions'
                    }
                  ]}
                  gridColumn={3}
                  defaultSelectedData={[]}
                  selectedData={selectedData}
                ></PageFilter>

                <div className="row table-list-container">
                  <GridTable
                    columns={UpdateColumnWithConfiguration(
                      transitionColumns,
                      this.state.configuration
                    )}
                    config={transitionListConfig}
                    data={transitionData}
                    renderActionColumn={this.renderActionColumn}
                    AddNewRecord={{
                      action: () => {
                        this.setState({
                          addEditView: true,
                          editMode: undefined,
                          selectedEditId: 0,
                          selectedTransitionId: 0,
                          selectedClientId: 0,
                          rowData: undefined,
                          readOnly: false
                        });
                      },
                      title: 'Add New Transition',
                      visible: IsSectionVisible(SECTIONS.PROPERTY_TRANSITION, 0, SECTIONS.ADD_EDIT),
                      disableAddButton: this.state.disableAddButton
                    }}
                  ></GridTable>
                </div>
              </>
            )}
      </>
    );
  }
}

export default Transition;
